import React from 'react'
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const User = () => {
  const navigate = useNavigate();
  const userInfo = useSelector(state => state.mainToCard.userInfo)

  React.useLayoutEffect(() => {
    if (userInfo?.userType === 0) {
      navigate(`/user/${userInfo?.userId}`)
    }
    else {
      navigate(`/users`)
    }
  }, [userInfo, navigate])

  return (
    <div>User</div>
  )
}

export default User